module.exports = require("./../../_gen/openfl/errors/IllegalOperationError");